import { useState, useEffect, useCallback } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV_LINKS = [
  { name: "Product", href: "#product" },
  { name: "How It Works", href: "#how-it-works" },
  { name: "Technology", href: "#technology" },
  { name: "Science", href: "#science" },
  { name: "Team", href: "#team" },
  { name: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 20);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-white/90 backdrop-blur-xl border-b border-slate-200 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <a href="#" data-testid="logo" className="flex items-center gap-3 group">
            <img
              src="https://customer-assets.emergentagent.com/job_1488b547-0470-4710-9082-0fb679cd81f3/artifacts/0ckydwjt_Orange%20kidney%20%281%29.jpg"
              alt="KidneyCheQ"
              className="h-12 w-12 object-contain"
            />
            <span className="font-display text-2xl md:text-3xl font-bold text-slate-800 group-hover:text-cyan-600 transition-colors">
              KidneyCheQ
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.name}
                href={link.href}
                data-testid={`nav-${link.name.toLowerCase().replace(/\s/g, '-')}`}
                className="text-slate-600 hover:text-cyan-600 transition-colors text-sm font-medium"
              >
                {link.name}
              </a>
            ))}
            <a href="#signup">
              <Button
                data-testid="nav-cta-button"
                className="bg-cyan-500 hover:bg-cyan-600 text-white font-semibold px-6"
              >
                Join Pre-Launch
              </Button>
            </a>
          </div>

          <button
            data-testid="mobile-menu-button"
            className="lg:hidden text-slate-800 p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div
            data-testid="mobile-menu"
            className="lg:hidden absolute top-full left-0 w-full bg-white/95 backdrop-blur-xl border-b border-slate-200 shadow-lg"
          >
            <div className="px-6 py-6 space-y-4">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="block text-slate-600 hover:text-cyan-600 transition-colors py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <a href="#signup" onClick={() => setIsMobileMenuOpen(false)}>
                <Button className="w-full bg-cyan-500 hover:bg-cyan-600 text-slate-800 font-semibold mt-4">
                  Join Pre-Launch
                </Button>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
